/*

Ashraf 12/07/2022 2698947782 add notes at search level
Ashraf 12/09/2022 2698947782 added reusable notes form
Akhila 12/09/2022 268947782 Added useEffect for reset the Table data
Ashraf 12/09/2022 2698947782 fixed reset notes issue
Dilip 12/12/2022 2698947782 changed tooltip
Ashraf 12/19/2022 2698947782 fixed notes search page break
kavyareddy 12/20/2022 2698947782 changed dropdown for createdBy and noteType paylaod
Raghu 12/26/2022 2698947782 Removed Dialog Component
Raghu 12/28/2022 2698947782 Table Footer Stylings
Suresh Peddavoora 02/24/2023 2698947782 New UI changes
Akhila 06/07/2023 2698947782 added code and description in action
Dilip-pds 10/19/2023 2698947782 fixed created by dropdown issue
Gireesh 14-12-2023 2698947782 updated payload
*/
import React, {createRef, useState, useEffect} from 'react';
import {TablePagination, Button, Grid} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from '@material-ui/icons/Add';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
import DialogBox from './../../../../../components/DialogBox/index';
import {
  postSystemNotes,
  resetNoteMessage,
} from '../../../../../redux/reducers/GlobalField/DataRepository';
import SearchNotesForm from '../../../../../components/SearchNotes/searchNotesForm';
import {DATA_REPOSITORY} from '../../../../../constants/ReusableRoleAccess';

const RepoNotes = ({
  open,
  dialogClose,
  title,
  maxWidth,
  value,
  handleSubmit,
  condition,
  buttonCondition,
  triggerData,
}) => {
  const [searchData, setSearchData] = useState();
  const [submit, setSubmit] = useState(false);

  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const {
    isSystemNoteLoading,
    systemNotesStatus,
  } = useSelector(({dataRepository}) => dataRepository);
  useEffect(() => {
    if (submit) {
      tableRef?.current?.onQueryChange();
    }
  }, [submit, searchData]);

  // User Defined notes successfully add then after 3 sec update system notes data and reset Data (2700799562)
  useEffect(() => {
    if (systemNotesStatus === 200) {
      tableRef?.current?.onQueryChange();
      handleDialogClose();
      setTimeout(() => {
        dispatch(resetNoteMessage());
      }, 3000);
    }
  }, [systemNotesStatus]);

  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        postSystemNotes({
          code: triggerData ? triggerData?.repositoryName : '',
          noteText: data,
          reportId: triggerData?.dataRepositoryId || 0
        }),
      );
    }
  };
  let transcription = '';
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        // minWidth: "550px",
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created By',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const {roleData} = useSelector(({role}) => role);
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };

  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  const dataRepoAccessAdd = !roleData?.window?.[DATA_REPOSITORY]?.['DR']?.add
  return (
    <>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            isLoading={isSystemNoteLoading}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            disableByRoleAccess={'enable'}
          />
        )}
      </DialogBox>
      <Grid className="system-notes-dialog">
        <SearchNotesForm
          setSearchData={setSearchData}
          searchData={searchData}
          submit={submit}
          setSubmit={setSubmit}
          triggerData={triggerData}
          moduleName={'datarepository'}
        />
        <div className="custom-table  custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-repository/find/all/datarepositorynotes`;
                const bodyObj = {
                  code: triggerData ? triggerData?.repositoryName : '',
                  frameworkId:  triggerData?.dataRepositoryId ? triggerData?.dataRepositoryId : 0,
                  limit: rows,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query.orderDirection,
                  search: '',
                  noteDate: searchData?.noteDate ?
                    moment(searchData?.noteDate).format('MM/DD/YYYY') :
                    '',
                  noteText: searchData?.noteText ? searchData?.noteText : '',
                  noteType: searchData?.noteType?.key ? searchData?.noteType?.key : '',
                  createdBy: searchData?.createdBy?.userLoginName ? searchData?.createdBy?.userLoginName : '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!triggerData?.repositoryName) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 5,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObjects;
                        resolve({
                          data: data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(response.data.response.resultObjects.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              toolbar: true,
              pageSizeOptions: tablePageRows,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              {
                icon: () => (
                  <div>
                    <Button variant="outlined" className="search-btn" disabled={dataRepoAccessAdd}>
                      <AddIcon /> Add
                    </Button>
                  </div>
                ),
                isFreeAction: true,
                disabled: dataRepoAccessAdd,
                onClick: () => handleSelectedNotesOption(),
              },
            ]}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    labelRowsPerPage={'Rows per screen:'}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
          />
        </div>
      </Grid>
    </>
  );
};

export default RepoNotes;
